import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const ChatButton = styled(Button)`
  height: 54px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.system.deepBlue};
  }
`;

export const ButtonIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;
